module.exports = __webpack_public_path__ + "img/filterIcon.4b4854df.svg";